import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/icon/del_sniff.png'
import _imports_1 from '@/assets/image/icon/floatrate/edit.png'
import _imports_2 from '@/assets/image/icon/upload_add.png'


const _withScopeId = n => (_pushScopeId("data-v-3d893293"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shop-express-config" }
const _hoisted_2 = { class: "express-country" }
const _hoisted_3 = { class: "express-name flex-ter" }
const _hoisted_4 = { class: "express-btn flex-ter" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "form" }
const _hoisted_12 = { class: "form-item flex-ter" }
const _hoisted_13 = { class: "form-item-title" }
const _hoisted_14 = { class: "form-item flex-ter" }
const _hoisted_15 = { class: "form-item-title" }
const _hoisted_16 = {
  key: 0,
  class: "express-select-prefix flex-center"
}
const _hoisted_17 = { class: "form-btn" }

import CommonDialog from '@/components/common/CommonDialog.vue'
import { t } from '@/plugins/i18n'
import { ref, onMounted, watch } from 'vue'
import { getCountryListApi, throughCountryGetExpressApi } from '@/apis/user'
import { isJA, isKO, isD2C } from '@/store'
import { getTotalCountryList, getAreaList, getAddressCodeName } from '@/util/useCountry'
import Form from '@/components/Signup/form.vue'
import { deleteConfigShopShipApi, getCustomerShopShipListApi, editConfigShopShipApi, addConfigShopShipApi } from '@/apis/setup'
import confirmDialog from '@/components/common/ConfirmDialog'
import { ElMessage } from 'element-plus'
import Image from '@/components/common/Image.vue'

// 获取组件默认国家商品的仓库code

export default /*#__PURE__*/_defineComponent({
  props: ['warehouseCode'],
  setup(__props) {

const props = __props


const visible = ref(false)
const getCountryName = (item: any) => {
  if (isJA() && item?.nameJa) return item?.nameJa
  if (isKO() && item?.nameKr) return item?.nameKr
  return item?.nameEn
}
const countryList: any = ref([])
const expressList: any = ref([])
const expressConfigList: any = ref([])
const activeLog: any = ref({})
const loading = ref(false)
const form: any = ref({
  logisticsId: '',
  countryCode: ''
})
const countryName = ref('')
onMounted(async () => {
  const list = await getTotalCountryList()
  const { data: countryResult } = await getCountryListApi({})
  console.log(88888888, countryResult)
  countryList.value = countryResult.map((i) => {
    return list.find((v) => v?.code === i?.countryCode)
  })
  getConfigList()
})
// TODO羽纱
// 当发生变化需求重新请求
watch(() => props.warehouseCode, () => {
  getConfigList()
})

const getConfigList = async () => {
  const resData: any = await getCustomerShopShipListApi({ warehouseCode: props.warehouseCode })
  expressConfigList.value = resData.data
}
const cancel = () => {
  visible.value = false
}
const submitLoading = ref(false)
const ok = async () => {
  if (!form.value.countryCode) {
    ElMessage.warning(t('请选择寄往国家'))
    return
  }
  if (!form.value.logisticsId) {
    ElMessage.warning(t('请选择物流公司'))
    return
  }
  submitLoading.value = true
  const api = form.value.customerShopShipId ? editConfigShopShipApi : addConfigShopShipApi
  const res = await api({ ...form.value, warehouseCode: props.warehouseCode })
  submitLoading.value = false
  if (!res.success) return
  ElMessage.success(t('保存成功'))
  visible.value = false
  getConfigList()
}
const changeCountry = async () => {
  expressList.value = []
  form.value.logisticsId = ''
  loading.value = true
  const res = await throughCountryGetExpressApi({
    countryCode: form.value.countryCode,
    systemSource: isD2C() ? 1 : 2,
    warehouseCode: props.warehouseCode
  })
  expressList.value = res.data
  loading.value = false
}
const add = () => {
  form.value = {
    logisticsId: '',
    countryCode: ''
  }
  visible.value = true
  expressList.value = []
}

const edit = async (item: any) => {
  if (item.countryCode) {
    form.value.countryCode = item.countryCode
    form.value.customerShopShipId = item.customerShopShipId
    await changeCountry()
    form.value.logisticsId = item.logisticsId
  }
  visible.value = true
}
const del = (item: { customerShopShipId: string }) => {
  confirmDialog({
    title: t('提示3'),
    text: t('是否删除')
  }).then(() => {
    deleteConfigShopShipApi({
      shopShipId: item.customerShopShipId
    }).then(() => {
      ElMessage.success(t('操作成功'))
      getConfigList()
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressConfigList.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "express-item",
          key: item.customerShopShipId
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(item.countryName), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Image, {
              src: item.logisticsLogo,
              class: "img"
            }, null, 8, ["src"]),
            _createElementVNode("span", null, _toDisplayString(item.logisticsName), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "del flex-ter cursor-pt",
              onClick: ($event: any) => (del(item))
            }, [
              _hoisted_6,
              _createTextVNode(_toDisplayString(_unref(t)('删除')), 1)
            ], 8, _hoisted_5),
            _createElementVNode("div", {
              class: "edit flex-ter cursor-pt",
              onClick: ($event: any) => (edit(item))
            }, [
              _hoisted_8,
              _createTextVNode(_toDisplayString(_unref(t)('修改')), 1)
            ], 8, _hoisted_7)
          ])
        ]))
      }), 128)),
      _createElementVNode("div", {
        class: "add-btn",
        onClick: add
      }, _hoisted_10)
    ]),
    _createVNode(CommonDialog, {
      onCancel: cancel,
      className: "shop-express-config-dialog",
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      width: 620,
      "append-to-body": "",
      title: _unref(t)('运送会社')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('寄往国家')), 1),
            _createVNode(_component_el_select, {
              class: "fx-1",
              onChange: changeCountry,
              modelValue: form.value.countryCode,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.countryCode) = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countryList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: getCountryName(item),
                    value: item?.code,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('选择物流公司')), 1),
            _withDirectives(_createVNode(_component_el_select, {
              class: _normalizeClass(["fx-1 express-select", { active: !!expressList.value?.find((v) => v.intShipConfigId === form.value.logisticsId)?.intShipConfigId }]),
              modelValue: form.value.logisticsId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.logisticsId) = $event))
            }, {
              prefix: _withCtx(() => [
                (expressList.value?.find((v) => v.intShipConfigId === form.value.logisticsId)?.intShipConfigId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(Image, {
                        src: expressList.value?.find((v) => v.intShipConfigId === form.value.logisticsId)?.logo,
                        class: "img"
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.distribution,
                    value: item.intShipConfigId,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "class"]), [
              [_directive_loading, loading.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: cancel,
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: ok,
              class: "btn",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})